module.exports = __webpack_public_path__ + "static/img/default.badb0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default.png
// module id = iDLf
// module chunks = 82